module.exports = __webpack_public_path__ + "img/essg1.fbc2659d.jpg";